// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__CMioW","inputWrap":"Table_inputWrap__1ERK6","col":"Table_col__3b67g","bmiTooltip":"Table_bmiTooltip__2eMXY"};